import { Box, IconButton, Stack } from '@mui/material'
import { memo } from 'react'
import { faClose } from '@fortawesome/pro-duotone-svg-icons'

import Text from '../shared/text/Text'
import AppWelcomeBox from './AppWelcomeBox'
import brandConfig from 'brandConfig'
import balanceIcon from 'assets/intro-02.png'
import stakingIcon from 'assets/intro-01.png'
import rewardsIcon from 'assets/intro-03.png'
import HowItWorksItem from './HowItWorksItem'
import FaIcon from 'src/components/shared/faIcon/FaIcon'

const HowItWorks = ({ t, symbol, onClose, closed }) => {
  const stepsList = [
    {
      title: t('how-it-works.stake-your'),
      desc: t('how-it-works.stake-your-desc'),
      icon: stakingIcon
    },
    {
      title: t('how-it-works.earn-points', { symbol }),
      desc: t('how-it-works.earn-points-desc', { symbol }),
      icon: balanceIcon
    },
    {
      title: t('how-it-works.get-epic-rewards'),
      desc: t('how-it-works.get-epic-rewards-desc', { symbol }),
      icon: rewardsIcon
    }
  ]
  return (
    <AppWelcomeBox sx={{ p: 3, position: 'relative' }}>
      {!closed && (
        <IconButton
          onClick={onClose}
          sx={{
            top: 12,
            right: 12,
            zIndex: 9,
            position: 'absolute',
            width: 36,
            height: 36
          }}
        >
          <FaIcon icon={faClose} size='sm' />
        </IconButton>
      )}
      <Stack sx={{ width: 1 }}>
        <Text
          variant='h4'
          sx={{ whiteSpace: 'pre-line', mb: 1 }}
          label={t('how-it-works.how-does-work', { name: brandConfig.name })}
        />
        <Text
          variant='body2'
          sx={{ mb: 2 }}
          label={t('how-it-works.how-does-work-desc')}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'flex-start',
            width: 1,
            gap: 2
          }}
        >
          {stepsList.map(({ title, ...restProps }, index) => (
            <HowItWorksItem
              key={index}
              title={`${index + 1}. ${title}`}
              {...restProps}
            />
          ))}
        </Box>
      </Stack>
    </AppWelcomeBox>
  )
}

export default memo(HowItWorks)
